import React, { Component } from "react";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import { GroupsAndActivitiesLogList_Url } from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import { BUSINESS_DOMAIN } from "../../../provider/Enums";
class GroupLogListDialog extends Component {
  header = store.getState().header.header;
  constructor(props) {
    super(props);
    this.state = {
      messageName: "",
      pageId: "",
      initialPage: 0,
      pageSize: 20,
      smsGroupList: [],
      activityList: [],
      open: false,
      isActivityPaging: false,
      isScheduled: false,
      isPaging: false,
      isAllOptins: false,
      isAllPending: false,
    };
  }

  showGroupLogList(rowData, pageId) {
    const postObject = {
      header: this.header,
      messageLog: {
        id: rowData.id,
      },
    };
    FetchServerData.callPostService(
      GroupsAndActivitiesLogList_Url,
      postObject
    ).then((output) => {
      if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
        let smsGroupList = output.data.groupList;
        let activityList = output.data.activityList;
        let isPaging = false;
        for (let i = 0; i < smsGroupList.length; i++) {
          smsGroupList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(smsGroupList[i].createdOn, true) : Utils.getUtcToLocalDateTimeZone(
            smsGroupList[i].createdOn, true
          );
        }
        if (smsGroupList.length > this.state.pageSize) {
          isPaging = true;
        }
        let isActivityPaging = false;
        for (let i = 0; i < activityList.length; i++) {
          activityList[i].createdOn = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventTimezone(activityList[i].createdOn, true) : Utils.getUtcToLocalDateTimeZone(
            activityList[i].createdOn, true
          );
        }
        if (activityList.length > this.state.pageSize) {
          isActivityPaging = true;
        }
        this.setState({
          open: true,
          isPaging: isPaging,
          pageId: pageId,
          isActivityPaging: isActivityPaging,
          messageName: rowData.messageName,
          isScheduled: rowData.status === "Scheduled" ? true : false,
          smsGroupList: smsGroupList,
          activityList: activityList,
          isAllOptins: rowData.isAllOptins,
          isAllPending: rowData.isAllPending,
        });
      } else {
      }
    });
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  render() {
    const isQuickText = this.state.messageName?.toLowerCase() === "quick text";
    return (
      <>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose.bind(this)}
          maxWidth="xl"
          className="activityDialogue"
        >
          <DialogTitle id="scroll-dialog-title">
            <span style={{ color: "#fff" }}>Groups Selected</span>
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={this.handleClose.bind(this)}
            style={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
          </IconButton>
          <DialogContent className="p-4">
            <>
              <div className="row">
                {this.state.isAllOptins && (
                  <p>
                    All opt-ins were sent this message:&nbsp;
                    <span style={{ fontWeight: 500 }}>
                      {this.state.messageName}
                    </span>
                  </p>
                )}
                {this.state.isAllPending &&
                  <p>All Pending numbers were send this message:&nbsp;
                    <span style={{ fontWeight: 500 }}>
                      {this.state.messageName}
                    </span></p>}
              </div>
              {this.state.smsGroupList.length > 0 && (
                <div
                  md={12}
                  className="tableContact materialTable"
                  style={{
                    width: "100%",
                    color: "#000",
                    fontSize: "small",
                  }}
                >
                  <MaterialTable
                    title={
                      !isQuickText ? (
                        <>
                          {`The members of these groups ${this.state.pageId === "ScheduledSend" &&
                            this.state.isScheduled
                            ? "will be"
                            : "were"
                            } sent message:`}
                          &nbsp;
                          <span style={{ fontWeight: "500" }}>
                            {this.state.messageName}
                          </span>
                        </>
                      ) : (
                        <>
                          The members of these groups were sent the Quick Text
                          message.
                        </>
                      )
                    }
                    icons={UiUtils.getMaterialTableIcons()}
                    localization={{
                      body: {
                        emptyDataSourceMessage: <h5>No data found.</h5>,
                      },
                    }}
                    columns={[
                      {
                        title: "#",
                        render: (rowData) => rowData.tableData.id + 1,
                        width: "5%",
                        align: "left",
                        cellStyle: {
                          width: "6%",
                        },
                      },
                      {
                        title: "Group Name",
                        field: "name",
                        cellStyle: {
                          width: "20%",
                        },
                      },
                      {
                        title: "Group Contacts",
                        field: "count",
                        cellStyle: {
                          width: "23%",
                        },
                      },
                      {
                        title: "Group Owner",
                        field: "createdby",
                        cellStyle: {
                          width: "17%",
                          textTransform: "none",
                        },
                      },
                      {
                        title: "",
                        field: "",
                        cellStyle: {
                          width: "22%",
                        },
                      },
                    ]}
                    data={this.state.smsGroupList}
                    options={{
                      showTextRowsSelected: false,
                      emptyRowsWhenPaging: false,
                      sorting: true,
                      search: false,
                      actionsColumnIndex: -1,
                      initialPage: this.state.initialPage,
                      pageSize: this.state.pageSize,
                      pageSizeOptions: Utils.materialTablePageSize(),
                      paging: this.state.isPaging,
                      // headerStyle: {
                      //   backgroundColor: "#37517e",
                      //   fontWeight: "bold",
                      //   color: "#fff",
                      //   align: "left",
                      // },
                      rowStyle: (rowData) => ({
                        backgroundColor:
                          rowData.id === this.state.contactId ? "#FEF5E7" : "",
                        height: "3em",
                        textTransform: "capitalize",
                      }),
                    }}
                    onSelectionChange={(rowData) => {
                      this.rowItemSelected(rowData);
                    }}
                    onChangePage={(page, pageSize) => {
                      this.handleMaterialTablePageChange(page, pageSize);
                    }}
                  />
                </div>
              )}
              {this.state.activityList.length > 0 && (
                <div
                  md={12}
                  className="mt-4 tableContact materialTable"
                  style={{
                    width: "100%",
                    color: "#000",
                    fontSize: "small",
                  }}
                >
                  <MaterialTable
                    title={
                      !isQuickText ? (
                        <>
                          {`These message recipients ${this.state.pageId === "ScheduledSend" &&
                            this.state.isScheduled
                            ? "will be"
                            : "were"
                            } sent message:`}
                          &nbsp;
                          <span style={{ fontWeight: "500" }}>
                            {this.state.messageName}
                          </span>
                        </>
                      ) : (
                        <>
                          The members of these groups were sent message: &nbsp;
                          <span style={{ fontWeight: "500" }}>
                            {this.state.messageName}
                          </span>
                        </>
                      )
                    }
                    icons={UiUtils.getMaterialTableIcons()}
                    localization={{
                      body: {
                        emptyDataSourceMessage: <h5>No data found.</h5>,
                      },
                    }}
                    columns={[
                      {
                        title: "#",
                        render: (rowData) => rowData.tableData.id + 1,
                        width: "5%",
                        align: "left",
                        cellStyle: {
                          width: "6%",
                        },
                      },
                      {
                        title: "Message Name",
                        field: "messageName",
                        cellStyle: {
                          width: "20%",
                        },
                      },
                      {
                        title: "Message Recipients",
                        field: "activeContacts",
                        cellStyle: {
                          width: "23%",
                        },
                      },
                      {
                        title: "Message Type",
                        field: "messageType",
                        cellStyle: {
                          width: "17%",
                        },
                      },
                      {
                        title: "Message keyword",
                        field: "messageKeyword",
                        cellStyle: {
                          width: "22%",
                        },
                      },
                    ]}
                    data={this.state.activityList}
                    options={{
                      showTextRowsSelected: false,
                      emptyRowsWhenPaging: false,
                      sorting: true,
                      search: false,
                      actionsColumnIndex: -1,
                      initialPage: this.state.initialPage,
                      pageSize: this.state.pageSize,
                      pageSizeOptions: Utils.materialTablePageSize(),
                      paging: this.state.isPaging,
                      // headerStyle: {
                      //   backgroundColor: "#37517e",
                      //   fontWeight: "bold",
                      //   color: "#fff",
                      //   align: "left",
                      // },
                      rowStyle: (rowData) => ({
                        backgroundColor:
                          rowData.id === this.state.contactId ? "#FEF5E7" : "",
                        height: "3em",
                        textTransform: "capitalize",
                      }),
                    }}
                    onSelectionChange={(rowData) => {
                      this.rowItemSelected(rowData);
                    }}
                    onChangePage={(page, pageSize) => {
                      this.handleMaterialTablePageChange(page, pageSize);
                    }}
                  />
                </div>
              )}
            </>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
export default GroupLogListDialog;
